module.exports = __webpack_public_path__ + "static/media/test-tube.25b4f71d.svg";